/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Approve_AnswerInputs */

const en_faq_approve_answer = /** @type {(inputs: Faq_Approve_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. We can design the system to prepare drafts, updates or recommendations for review. Together, we define which actions need approval and which can happen automatically.`)
};

const lv_faq_approve_answer = /** @type {(inputs: Faq_Approve_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Sistēmu varam veidot tā, lai tā sagatavo melnrakstus, atjauninājumus vai ieteikumus pārskatīšanai. Kopā nosakām, kurām darbībām vajadzīgs apstiprinājums un kuras var notikt automātiski.`)
};

/**
* | output |
* | --- |
* | "Yes. We can design the system to prepare drafts, updates or recommendations for review. Together, we define which actions need approval and which can happen ..." |
*
* @param {Faq_Approve_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_approve_answer = /** @type {((inputs?: Faq_Approve_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Approve_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_approve_answer(inputs)
	return en_faq_approve_answer(inputs)
});